import { render, staticRenderFns } from "./DescriptionSide.vue?vue&type=template&id=7aa8bf8c&scoped=true&"
import script from "./DescriptionSide.vue?vue&type=script&lang=js&"
export * from "./DescriptionSide.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionSide.vue?vue&type=style&index=0&id=7aa8bf8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa8bf8c",
  null
  
)

export default component.exports